import Service from "../../service";
import { axios } from "services/axios";

const DonationService = {
  // get list of batch billings
  getListofTributeInfo: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/transaction/tribute?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  addTributeById: async (id, data, token) => {
    try {
      return await Service.post({
        url: `/finance/v1/transaction/tribute/${id}`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  editTributeById: async (id, data, token) => {
    try {
      return await Service.update({
        url: `/finance/v1/transaction/tribute/${id}`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  // SEND TRIBUTE LETTER
  sendTributeLetter: async (token, data) => {
    try {
      return await Service.post({
        url: `/finance/v1/transaction/tribute/letter`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  // ADD BULK TAGGING
  addBulkTagging: async (token, data) => {
    try {
      return await Service.post({
        url: `/finance/v1/transaction/tribute/tags`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  // Bulk Download
  addBulkDownload: async (token, data) => {
    try {
      return await axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/finance/v1/document/donation/bulk`,
        responseType: "blob",
        data: data,
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${token}`,
          "Access-Control-Expose-Headers": "Content-Disposition",
        },
      });
    } catch (error) {
      throw error;
    }
  },
};

export default DonationService;
